export const categories = [
  {
    id: 'video-platforms',
    name: '视频平台',
    slug: 'video-platforms',
    description: '精选优质成人视频平台，海量高清资源在线观看',
    icon: 'ri-movie-line',
    count: 128,
  },
  {
    id: 'live-streaming',
    name: '直播平台',
    slug: 'live-streaming',
    description: '热门成人直播平台推荐，真人互动直播体验',
    icon: 'ri-live-line',
    count: 86,
  },
  {
    id: 'image-gallery',
    name: '图片社区',
    slug: 'image-gallery',
    description: '高清成人图片社区与相册资源导航',
    icon: 'ri-image-line',
    count: 95,
  },
  {
    id: 'forums',
    name: '社区论坛',
    slug: 'forums',
    description: '活跃成人交流社区，资源分享与讨论',
    icon: 'ri-chat-3-line',
    count: 64,
  },
  {
    id: 'novels',
    name: '小说文学',
    slug: 'novels',
    description: '成人文学作品与小说阅读平台精选',
    icon: 'ri-book-open-line',
    count: 72,
  },
  {
    id: 'dating',
    name: '交友社交',
    slug: 'dating',
    description: '成人社交交友平台，真实互动体验',
    icon: 'ri-heart-line',
    count: 53,
  },
  {
    id: 'games',
    name: '游戏娱乐',
    slug: 'games',
    description: '成人向游戏与互动娱乐平台导航',
    icon: 'ri-gamepad-line',
    count: 41,
  },
  {
    id: 'tools',
    name: '工具资源',
    slug: 'tools',
    description: '成人内容相关的实用工具与资源下载',
    icon: 'ri-tools-line',
    count: 38,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};